import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Locatie, LocatieUpdate } from './locatii.interface';

@Injectable({
    providedIn: 'root'
})
export class LocatiiService {
    private basePath = environment.interop.basePath;

    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.delete;
    private listActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.listActive;
    private listPublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.listPublic;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.locatii.updatePublic;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.get(this.listUrl);
    }

    add(locatie: Locatie) {
        return this.http.post(this.storeUrl, locatie);
    }

    update(locatie: LocatieUpdate) {
        return this.http.put(this.updateUrl, locatie);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    listActive() {
        return this.http.get(this.listActiveUrl);
    }

    listPublic() {
        return this.http.get(this.listPublicUrl);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }
}
